import {type ReactNode, useState, type JSX} from 'react'
import {ToggleContext} from './toggle-context'

type ToggleProviderProps = {
    children: ReactNode
}
export function ToggleProvider({children}: ToggleProviderProps): JSX.Element {
    const [value, setValue] = useState<boolean>(false)
    return <ToggleContext value={{value, setValue}}>{children}</ToggleContext>
}
